import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Pricing extends Component {

    renderGreen(text) {
        return (
            <div className="panel-block px-5">
                <span className="panel-icon"><i className="fas fa-check has-text-success" aria-hidden="true"></i></span>{text}
            </div>
        );
    }

    renderYellow(text) {
        return (
            <div className="panel-block px-5">
                <span className="panel-icon"><i className="fas fa-check has-text-warning" aria-hidden="true"></i></span>{text}
            </div>
        );
    }

    renderRed(text) {
        return (
            <div className="panel-block px-5">
                <span className="panel-icon"><i className="fas fa-times has-text-danger" aria-hidden="true"></i></span>{text}
            </div>
        );
    }

    renderInfinity(text) {
        return (
            <div className="panel-block px-5">
                <span className="panel-icon"><i className="fas fa-check-double has-text-success" aria-hidden="true"></i></span>{text}
            </div>
        );
    }

    renderButton(buttonClassName) {
        if (this.props.user) {
            return (
                <div className="panel-block">
                    <Link to="/config" className={`button is-fullwidth ${buttonClassName}`}>
                        Gerir Subscrição
                    </Link>
                </div>
            );
        }

        return (
            <div className="panel-block">
                <Link to="/registar" className={`button is-fullwidth ${buttonClassName}`}>
                    Criar conta
                </Link>
            </div>
        );
    }

    renderSoonButton(buttonClassName) {
        return (
            <div className="panel-block">
                <button className={`button is-fullwidth ${buttonClassName}`} disabled>
                    Sob Consulta
                </button>
            </div>
        );
    }

    renderTrialPanel() {
        return (
            <nav className="panel has-background-white">
                <div className="panel-block has-text-grey-dark" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="is-size-4 has-text-weight-bold my-3">Experimental</div>
                    <div className="mb-3">
                        <span className={"is-size-2 has-text-weight-bold mr-2"}>Grátis</span>/<span className="is-size-6 has-text-weight-normal ml-1">7 dias</span>
                    </div>
                    <div className="mb-3 has-text-centered is-size-7">
                        Experimente sem qualquer custo ou compromisso.
                    </div>
                </div>
                { this.renderYellow("1 utilizador") }
                { this.renderYellow("1 entidade") }
                { this.renderYellow("3 receitas / fichas técnicas") }
                { this.renderYellow("2 ingredientes") }
                { this.renderGreen("1376 alimentos com 48 valores nutricionais") }
                { this.renderGreen("14 alergénios") }
                { this.renderGreen("Adicionar novos alimentos") }
                { this.renderGreen("Percentagem edível automática") }
                { this.renderGreen("Cálculo nutricional automático") }
                { this.renderRed("Partilha de fichas técnicas entre utilizadores") }
                { this.renderButton("") }
            </nav>
        );
    }

    renderProPanel() {
        const color = "success";

        return (
            <nav className="panel has-background-white">
                <div className="panel-block has-text-grey-dark" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="is-size-4 has-text-weight-bold my-3">Profissional</div>
                    <div className="mb-0">
                        <span className={`is-size-2 has-text-weight-bold mr-2 has-text-${color}`}>10€</span>/<span className="is-size-6 has-text-weight-normal ml-1">mês *</span>
                    </div>
                    <div className="mb-3">
                        <div className={`tag has-text-weight-bold is-${color}`}>Faturado 120€ anualmente</div>
                    </div>
                    <div className="mb-3 has-text-centered is-size-7">
                        Plano ideal para profissionais, empresas e instituições que criam fichas técnicas para uma ou mais entidades (por exemplo nutricionistas, câmaras municipais, juntas de freguesia, restaurantes, ginásios, hospitais, escolas, creches e lares).
                    </div>
                </div>
                { this.renderYellow("1 utilizador") }
                { this.renderGreen("Entidades ilimitadas") }
                { this.renderGreen("Receitas / fichas técnicas ilimitadas") }
                { this.renderGreen("Ingredientes ilimitados") }
                { this.renderGreen("1376 alimentos com 48 valores nutricionais") }
                { this.renderGreen("14 alergénios") }
                { this.renderGreen("Adicionar novos alimentos") }
                { this.renderGreen("Percentagem edível automática") }
                { this.renderGreen("Cálculo nutricional automático") }
                { this.renderRed("Partilha de fichas técnicas entre utilizadores") }
                { this.renderButton(`is-${color}`) }
            </nav>
        );
    }

    renderCompanyPanel() {
        const color = "info";

        return (
            <nav className="panel has-background-white">
                <div className="panel-block has-text-grey-dark" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="is-size-4 has-text-weight-bold my-3">Corporativo</div>
                    <div className="mb-0">
                        <span className={`is-size-2 has-text-weight-bold mr-2 has-text-${color}`}>50€</span>/<span className="is-size-6 has-text-weight-normal ml-1">mês *</span>
                    </div>
                    <div className="mb-3">
                        <div className={`tag has-text-weight-bold is-${color}`}>Faturado 600€ anualmente</div>
                    </div>
                    <div className="mb-3 has-text-centered is-size-7">
                        Plano ideal para empresas com múltiplos profissionais que colaboram na gestão de fichas técnicas.
                    </div>
                    <div className="mb-3 has-text-centered is-size-7">
                        O valor base inclui 3 utilizadores.<br/>Cada utilizador adicional acresce 5€/mês *.
                    </div>
                    <div className="mb-3 has-text-centered is-size-7">
                        Por favor entre em contato connosco através do email <a href="mailto:info@nutrit.pt?subject=Plano%20Corporativo%20-%20Solicita%C3%A7%C3%A3o%20de%20Proposta" target="_blank" rel="noreferrer">info@nutrit.pt</a>.
                    </div>
                </div>
                { this.renderGreen("3 utilizadores incluídos") }
                { this.renderGreen("Entidades ilimitadas") }
                { this.renderGreen("Receitas / fichas técnicas ilimitadas") }
                { this.renderGreen("Ingredientes ilimitados") }
                { this.renderGreen("1376 alimentos com 48 valores nutricionais") }
                { this.renderGreen("14 alergénios") }
                { this.renderGreen("Adicionar novos alimentos") }
                { this.renderGreen("Percentagem edível automática") }
                { this.renderGreen("Cálculo nutricional automático") }
                { this.renderGreen("Partilha de fichas técnicas entre utilizadores") }
                <div className="panel-block">
                    <a className={`button is-fullwidth is-${color}`} href="mailto:info@nutrit.pt?subject=Plano%20Corporativo%20-%20Solicita%C3%A7%C3%A3o%20de%20Proposta">
                        Solicitar Proposta
                    </a>
                </div>
            </nav>
        );
    }

    render() {
        return (
            <>
                <section id="precario" className="section is-medium">
                    <div className="container">
                        <header>
                            <p className="title has-text-grey-dark has-text-centered">Preçário</p>
                        </header>
                        <div className="columns" style={{ alignItems: 'flex-end' }}>
                            <div className="column">
                                {this.renderTrialPanel()}
                            </div>
                            <div className="column">
                                {this.renderProPanel()}
                            </div>
                            <div className="column">
                                {this.renderCompanyPanel()}
                            </div>
                        </div>
                        <div className="has-text-grey">
                            * Aos valores apresentados acresce IVA à taxa legal de 23%.
                        </div>
                    </div>
                </section>

            </>
        );
    }
}

export default Pricing;
